import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request from '../../utils/request';
import Locked from './Locked';

import {
  actionsSalesRepWithSrt,
  actionsSrtGroup,
  actionsRest
} from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { role_id: role, email } = request.getProfile();

  const getActions = () => {
    let action;
    switch (role) {
      case 9:
        action = actionsSalesRepWithSrt;
        break;
      case 4:
        action = actionsSrtGroup;
        break;
      default:
        action = actionsRest;
    }
    return action;
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        _.get(getActions(), status, []).map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
